import { mapGetters } from 'vuex';
import mSelect from '@/components/lots/otpSelect2/index';
import upload from '../../../../components/upload/Index.vue';
import preview from '../../../../components/viewAttachment.vue';
import { NOT_INVOLVE, OS_LGT } from '../../../../constant/constant.js';
import {
    PERSON,
    COMPANY,
    ABROAD,
    ORGANIZATION,
    HKMCTW,
    LOGISTICS_SUPPLIER,
    INNER_SUPPLIER,
    STAFF_SUPPLIER,
    OCEANFREIGHT_SUPPLIER,
    TRANSPORTATION_NUM,
    EXPRESS_NUM,
    STORAGE_NUM,
    LEASING_STORAGE_NUM,
    LEASING_STORAGE_LEASE_NUM,
    HOME_DELIVERY_NUM,
    DS_NUM,
    BG_NUM,
    DISPATCH_NUM,
    OTHER_SUPPLIER,
    TPT_OTHER_NUM,
    TPT_BG_NUM,
    TPT_DS_NUM,
} from '../../../../constant/supplierListConstant.js';
import { dictWithUrl } from '@/components/lots/api';
import { identityVerify, phoneVerify } from '../../../../constant/formRegular.js';
import { chooseSupplierType, supplierTypeConfigAssociation, confirmSupplierType, confirmIntrofuce } from '../../../../api/register/supplierList.js';
import { verifyDate } from '../../../../utils/common.js';

export default {
    name: 'add-or-edit-dialog',
    components: { mSelect, upload, preview },
    props: {
        openAddOrEditDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        overseaSwitch: {
            type: Boolean,
            default() {
                return true;
            }
        },
    },
    data() {
        return {
            COMPANY,
            ABROAD,
            HKMCTW,
            LOGISTICS_SUPPLIER,
            STAFF_SUPPLIER,
            title: '新增',
            allow: false,
            confirmDisabled: false,
            form: {
                supplierNameCn: '',
                corporateName: '',
                principalName: '',
                supplierType: '',
                propertyNature: '',
                isOverseas: '',
                businessTypeList: [],
                transportType: '',
                transType: '', // 业务类型控制承运商类别
                corporateType: '',
                lesseeType: '',
                idCard: '',
                phone: '',
                userCode: '',
                businessLicense: '',
                uploadIdentityFront: '',
                uploadIdentityBehind: '',
                idCardStartTime: '',
                idCardEndTime: '',
                cooperationWays: ''
            },
            submitForm: {}, // 经处理后的form参数，用于接口参数
            options: { // 选项集合，Options后缀的是后端返回经过筛选的可选项，Arr后缀的是对应字典的所有选项
                supplierTypeOptions: [],
                propertyNatureOptions: [],
                isOverseasOptions: [],
                businessTypeListOptions: [],
                transportTypeOptions: [],
                transTypeOptions: [],
                corporateTypeOptions: [],
                lesseeTypeOptions: [],
                businessTypeListArr: [],
                corporateTypeArr: [],
                transTypeArr: [],
                transportTypeArr: [],
                lesseeTypeArr: []
            },
            loading: false,
            isChina: '0',
            uploadDisplayType: 'icon',
            uploatFlag: {},
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
            idTypes: ['front', 'behind', 'businessLicense'],
            isForever: false
        };
    },
    computed: {
        ...mapGetters(['currentTenant']),
        updateForm() {
            return this.form.supplierType + this.form.propertyNature;
        },
        propertyNature() {
            return this.form.propertyNature;
        },
        businessTypeListForm() {
            return this.form.businessTypeList;
        },
        corporateTypeForm() {
            return this.form.corporateType;
        },
        transportTypeForm() {
            return this.form.transportType;
        },
        labelName() {
            const name = [COMPANY, ABROAD, HKMCTW].includes(this.form.propertyNature) ? '法人' : '负责人';
            return name;
        },
        rules() {
            const validateLessThanToday = (rule, value, callback) => {
                if ((new Date()) < (new Date(value + ' 23:59:59'))) {
                    callback(new Error('起始日必须小于当前日期'));
                } else {
                    callback();
                }
            };
            const validateMoreThanToday = (rule, value, callback) => {
                if ((new Date()) > (new Date(value + ' 00:00:00'))) {
                    callback(new Error('到期日必须大于当前日期'));
                } else {
                    callback();
                }
            };
            const name = [COMPANY, ABROAD, HKMCTW].includes(this.form.propertyNature) ? '法人' : '负责人';
            const rulesObj = {
                supplierType: [{ required: true, message: '请选择供应商类型', trigger: ['blur', 'change'] }],
                propertyNature: [{ required: true, message: '请选择主体性质', trigger: ['blur', 'change'] }],
                isOverseas: [{ required: true, message: '请选择涉外业务类型', trigger: ['blur', 'change'] }],
                supplierNameCn: [{ required: true, message: '请输入供应商名称', trigger: ['blur', 'change'] }],
                businessLicense: [{ required: true, message: '请上传营业执照照片', trigger: ['blur', 'change'] }],
                uploadIdentityFront: [{ required: true, message: '请上传身份证照(人像面)', trigger: ['blur', 'change'] }],
                uploadIdentityBehind: [{ required: true, message: '请上传身份证照(国徽面)', trigger: ['blur', 'change'] }],
                principalName: [{ required: true, message: `请输入负责人姓名`, trigger: ['blur', 'change'] }],
                corporateName: [{ required: true, message: `请输入法人姓名`, trigger: ['blur', 'change'] }],
                idCard: [
                    { required: true, message: `请输入${name}身份证号`, trigger: ['blur', 'change'] },
                    { pattern: identityVerify, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] }
                ],
                phone: [
                    { required: true, message: '请输入负责人手机号', trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] }
                ],
                userCode: [{ required: true, message: '请输入员工账号', trigger: ['blur', 'change'] }],
                idCardStartTime: [
                    { required: true, message: '请选择起始日期', trigger: ['blur', 'change'] },
                    { validator: validateLessThanToday, trigger: ['blur', 'change'] }
                ],
                idCardEndTime: [
                    { required: true, message: '请选择到期日期', trigger: ['blur', 'change'] },
                    { validator: validateMoreThanToday, trigger: ['blur', 'change'] }
                ],
                businessTypeList: [{ required: true, message: '请选择业务类型', trigger: ['blur', 'change'] }],
                transportType: [{ required: true, message: '请选择运输方式', trigger: ['blur', 'change'] }],
                transType: [{ required: true, message: '请选择承运商类型', trigger: ['blur', 'change'] }],
                corporateType: [{ required: true, message: '请选择合作方式', trigger: ['blur', 'change'] }],
                lesseeType: [{ required: true, message: '请选择租赁商类别', trigger: ['blur', 'change'] }],
                cooperationWays: [{ required: true, message: '请选择合作方式(其他)', trigger: ['blur', 'change'] }]
            };
            return rulesObj;
        },
        idVisible() { // （供应商类型不是员工供应商）&&（供应商类型：物流供应商）&&（主体性质不是非营利机构）
            return this.form.supplierType && this.form.supplierType !== STAFF_SUPPLIER && ((this.form.supplierType === LOGISTICS_SUPPLIER &&
                    this.form.propertyNature && this.form.propertyNature !== ORGANIZATION) || (this.form.supplierType !== LOGISTICS_SUPPLIER && this.form.propertyNature === PERSON));
        }
    },
    methods: {
        // 获取提交需要的form非空参数
        handleUpdateForm() {
            if (this.form.supplierType && this.form.propertyNature) {
                const form = this.handleFormData();
                Object.keys(form).forEach(e => {
                    if (!form[e]) {
                        delete form[e];
                    }
                });
                this.submitForm = JSON.parse(JSON.stringify(form));
            }
        },
        // 根据条件提取form参数
        handleFormData() {
            const list = ['isOverseas', 'principalName', 'corporateName', 'idCard', 'phone', 'userCode', 'supplierNameCn', 'businessTypeList',
                'transportType', 'transType', 'corporateType', 'lesseeType', 'businessLicense', 'uploadIdentityFront', 'uploadIdentityBehind', 'idCardStartTime', 'idCardEndTime', 'cooperationWays'];
            const form = {};
            list.forEach(e => {
                if (this.checkVisibleFormItems(e)) {
                    form[e] = this.form[e];
                }
            });
            form.propertyNature = this.form.propertyNature;
            form.supplierType = this.form.supplierType;
            if (this.idVisible && this.form.propertyNature && this.form.propertyNature !== ORGANIZATION) {
                form.isChina = this.isChina;
            }
            if (this.checkVisibleFormItems('businessLicense')) {
                form.businessLicense = this.form.businessLicense;
                form.businessLicenseUrl = this.form.businessLicenseUrl;
                form.businessLicenseFileId = this.form.businessLicenseFileId;
            }
            if (this.idVisible) {
                form.uploadIdentityFront = this.form.uploadIdentityFront;
                form.uploadIdentityFrontUrl = this.form.uploadIdentityFrontUrl;
                form.uploadIdentityFrontFileId = this.form.uploadIdentityFrontFileId;
                form.uploadIdentityBehind = this.form.uploadIdentityBehind;
                form.uploadIdentityBehindUrl = this.form.uploadIdentityBehindUrl;
                form.uploadIdentityBehindFileId = this.form.uploadIdentityBehindFileId;
                form.idCardStartTime = this.form.idCardStartTime;
                form.idCardEndTime = this.form.idCardEndTime;
            }
            return form;
        },
        closeDialog() {
            this.$emit('closeDialog', false);
        },
        handleConfirm() {
            this.handleVerify();
            if (this.allow) {
                this.handleUpdateForm();
                this.confirmSupplier();
            }
        },
        confirmSupplier() {
            this.loading = true;
            // if (this.submitForm.supplierNameCn) {
            //     this.submitForm.supplierNameCn = this.submitForm.supplierNameCn.replace(/（/g, '(').replace(/）/g, ')').replace(/，/g, ',').toUpperCase();
            // }
            ['supplierNameCn', 'corporateName', 'principalName'].forEach(key => { // 去前后空格
                if (this.submitForm[key]) {
                    this.submitForm[key] = this.submitForm[key].trim();
                }
            });
            if (this.submitForm.idCard) {
                this.submitForm.idCard = this.submitForm.idCard.toUpperCase();
            }
            confirmSupplierType(this.submitForm).then(res => {
                this.loading = false;
                if (res && +res.code === 0) {
                    if (res.msg === '110123') {
                        this.$confirm('供应商主信息已经存在,是否确认引入？', '引入确认', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            const params = {
                                ...this.submitForm,
                                supplierNameCn: res.data.supplierNameCn,
                                supplierCode: res.data.supplierCode,
                                tenantName: this.currentTenant.tenantName
                            };
                            confirmIntrofuce(params).then(gres => {
                                this.$message.success('引入成功');
                                this.$router.push({
                                    path: '/keyData/detail',
                                    query: {
                                        businessType: this.submitForm.businessTypeList[0], propertyNature: this.submitForm.propertyNature, supplierCode: res.data.supplierCode
                                    }
                                });
                            });
                        });
                    } else {
                        const query = { propertyNature: this.submitForm.propertyNature, supplierCode: res.data };
                        if (this.submitForm.businessTypeList && this.submitForm.businessTypeList.length) {
                            query.businessType = this.submitForm.businessTypeList[0];
                        }
                        this.$router.push({ path: '/keyData/detail', query });
                    }
                    this.allow = false;
                    this.$emit('confirmDialog', false);
                }
            }).catch(e => { this.loading = false; });
        },
        handleVerify() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.allow = true;
                } else {
                    const CLEAR_DELAY = 2500;
                    const props = ['supplierType', 'propertyNature', 'isOverseas', 'supplierNameCn', 'principalName', 'businessTypeList', 'transportType', 'transType', 'corporateType', 'lesseeType',
                        'businessLicense', 'uploadIdentityFront', 'uploadIdentityBehind', 'idCardStartTime', 'idCardEndTime', 'corporateName', 'idCard', 'phone', 'cooperationWays'];
                    setTimeout(() => {
                        props.forEach(prop => {
                            this.$refs.form.clearValidate(prop);
                        });
                    }, CLEAR_DELAY);
                }
            });
        },
        resetForm() {
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
                this.form.businessLicenseUrl = '';
                this.form.uploadIdentityFrontUrl = '';
                this.form.uploadIdentityBehindUrl = '';
                this.submitForm = {};
            }
        },
        uploadSuccess(data, type) {
            if (data.ocr) {
                let clearFlag = false;
                if (type === this.idTypes[0]) {
                    this.form.uploadIdentityFront = data.data.ossResult.localFileName;
                    this.form.uploadIdentityFrontUrl = data.data.ossResult.downUrl;
                    this.form.uploadIdentityFrontFileId = data.data.ossResult.id;
                    this.form.principalName = data.data.ocrResult.name;
                    this.form.corporateName = data.data.ocrResult.name;
                    this.form.idCard = data.data.ocrResult.idNumber;
                    clearFlag = data.data.ocrResult.name && data.data.ocrResult.idNumber;
                } else if (type === this.idTypes[1]) {
                    this.form.uploadIdentityBehind = data.data.ossResult.localFileName;
                    this.form.uploadIdentityBehindUrl = data.data.ossResult.downUrl;
                    this.form.uploadIdentityBehindFileId = data.data.ossResult.id;
                    this.form.idCardStartTime = verifyDate(data.data.ocrResult.idCardStartTime);
                    this.form.idCardEndTime = data.data.ocrResult.idCardEndTime === '长期' ? '2099-12-31' : verifyDate(data.data.ocrResult.idCardEndTime);
                    this.isForever = data.data.ocrResult.idCardEndTime === '长期';
                    clearFlag = data.data.ocrResult.idCardStartTime && data.data.ocrResult.idCardEndTime;
                } else if (type === this.idTypes[2]) {
                    this.form.businessLicense = data.data.ossResult.localFileName;
                    this.form.businessLicenseUrl = data.data.ossResult.downUrl;
                    this.form.businessLicenseFileId = data.data.ossResult.id;
                    this.form.supplierNameCn = data.data.ocrResult.biz_license_company_name;
                    clearFlag = !!data.data.ocrResult.biz_license_company_name;
                }
                if (clearFlag) {
                    this.$message.success('附件上传成功');
                } else {
                    this.$message.warning({ message: '证件真实性或清晰度欠佳，若条件允许，建议重新上传！', duration: 6000 });
                }
                return;
            }
            if (type === this.idTypes[0]) {
                this.form.uploadIdentityFront = data.data.data.localFileName;
                this.form.uploadIdentityFrontUrl = data.data.data.downUrl;
                this.form.uploadIdentityFrontFileId = data.data.data.id;
            } else if (type === this.idTypes[1]) {
                this.form.uploadIdentityBehind = data.data.data.localFileName;
                this.form.uploadIdentityBehindUrl = data.data.data.downUrl;
                this.form.uploadIdentityBehindFileId = data.data.data.id;
            } else if (type === this.idTypes[2]) {
                this.form.businessLicense = data.data.data.localFileName;
                this.form.businessLicenseUrl = data.data.data.downUrl;
                this.form.businessLicenseFileId = data.data.data.id;
            }
            this.$message.success('附件上传成功');
        },
        handleCheckboxChange(val) {
            this.form.idCardEndTime = val ? '2099-12-31' : '';
        },
        // 表格各项的展示控制条件
        checkVisibleFormItems(prop) {
            let visible = false;
            const { form, idVisible } = this;
            const { propertyNature, supplierType, businessTypeList, transportType, corporateType } = form;
            // 各下拉框判断逻辑
            if (prop === 'isOverseas') { // 涉外业务类型：（开关打开 且 供应商类型：物流供应商）
                visible = this.overseaSwitch && supplierType === LOGISTICS_SUPPLIER;
            } else if (prop === 'supplierNameCn') { // 供应商名称：（主体性质：法人|国外|港澳台|非营利机构）
                visible = [COMPANY, ABROAD, HKMCTW, ORGANIZATION].includes(propertyNature);
            } else if (prop === 'corporateName') { // 法人姓名：（主体性质：法人|国外|港澳台）&&（供应商类型：!海运费供应商|!员工供应商）
                visible = supplierType !== OCEANFREIGHT_SUPPLIER && supplierType !== STAFF_SUPPLIER && [COMPANY, ABROAD, HKMCTW].includes(propertyNature);
            } else if (prop === 'principalName' || prop === 'phone') { // 负责人姓名\负责人手机号码：主体性质是个体且供应商类型不是员工供应商
                visible = supplierType !== STAFF_SUPPLIER && propertyNature === PERSON;
            } else if (prop === 'idCard') { // 身份证号：
                visible = idVisible;
            } else if (prop === 'userCode') { // 员工账号：（供应商类型：员工供应商）&&（主体性质：个体）
                visible = supplierType === STAFF_SUPPLIER && propertyNature === PERSON;
            } else if (prop === 'businessTypeList') { // 业务类型：（供应商类型：物流供应商|内部供应商）
                visible = (supplierType === LOGISTICS_SUPPLIER || supplierType === INNER_SUPPLIER);
            } else if (prop === 'transportType') { // 运输方式：（供应商类型：物流供应商|内部供应商）&&（业务类型：运输|电商|报关）
                visible = businessTypeList.some(item => [TRANSPORTATION_NUM, DS_NUM, BG_NUM].includes(item)) &&
                    (supplierType === LOGISTICS_SUPPLIER || supplierType === INNER_SUPPLIER);
            } else if (prop === 'transType') {
                // 承运商类别：
                // （供应商类型：物流供应商|内部供应商）&&（业务类型：快递|宅配|配送|（运输方式存在 && 业务类型：运输））||
                // (运输方式：其他|电商|报关)
                visible = ((businessTypeList.some(item => [EXPRESS_NUM, HOME_DELIVERY_NUM, DISPATCH_NUM].includes(item)) || (transportType &&
                    businessTypeList.indexOf(TRANSPORTATION_NUM) >= 0)) && (supplierType === LOGISTICS_SUPPLIER || supplierType === INNER_SUPPLIER)) ||
                    ([TPT_OTHER_NUM, TPT_BG_NUM, TPT_DS_NUM].includes(transportType));
            } else if (prop === 'corporateType') { // 合作方式：（供应商类型：物流供应商|内部供应商） && （业务类型：仓储）
                visible = businessTypeList.indexOf(STORAGE_NUM) >= 0 && (supplierType === LOGISTICS_SUPPLIER || supplierType === INNER_SUPPLIER);
            } else if (prop === 'lesseeType') { // 租赁商类别：（供应商类型：物流供应商|内部供应商））&&（业务类型：仓储）&&（合作方式：仓库租赁|仓管及仓租）
                visible = businessTypeList.indexOf(STORAGE_NUM) >= 0 && (corporateType === LEASING_STORAGE_NUM || corporateType === LEASING_STORAGE_LEASE_NUM) &&
                (supplierType === LOGISTICS_SUPPLIER || supplierType === INNER_SUPPLIER);
            } else if (prop === 'cooperationWays') { // 合作方式(其他)：（供应商类型：其他供应商）
                visible = supplierType === OTHER_SUPPLIER;
            } else if (prop === 'businessLicense') { // 营业执照：（供应商类型：物流供应商）&& （主体性质：法人）
                visible = supplierType === LOGISTICS_SUPPLIER && propertyNature === COMPANY;
            }
            return visible;
        },
        propsChange1(data, prop) { // 合作方式(其他)选择后回调
            this.form[prop] = data;
        },
        handlePreview(url) {
            this.attachmentShow = true;
            this.rowData = { downUrl: url };
        },
        handleOSChange() {
            this.form.businessTypeList = [];
            this.handleUpdateForm();
            if (Object.keys(this.submitForm).length) {
                this.confirmDisabled = true;
                chooseSupplierType(this.submitForm).then(res => {
                    this.options.businessTypeListOptions = [];
                    if (res && +res.code === 0) {
                        if (res.data && res.data.length) {
                            this.options.businessTypeListArr.forEach(e => {
                                for (const i of new Set(res.data)) {
                                    if (String(i) === e.value) {
                                        this.options.businessTypeListOptions.push(e);
                                    }
                                }
                            });
                        }
                    }
                }).finally(() => { this.confirmDisabled = false; });
            }
        },
    },
    watch: {
        openAddOrEditDialog() {
            this.resetForm();
        },
        propertyNature() {
            this.form.transType = '';
            this.form.transportType = '';
            this.form.businessTypeList = [];
        },
        updateForm(val) {
            if (!val) { return false; } // 置空后取消执行
            if (this.form.supplierType === STAFF_SUPPLIER) {
                this.form.propertyNature = PERSON;
            }
            if (this.form.supplierType === LOGISTICS_SUPPLIER) {
                if ([COMPANY, PERSON].includes(this.form.propertyNature)) {
                    this.form.isOverseas = NOT_INVOLVE;
                } else if ([ABROAD, HKMCTW].includes(this.form.propertyNature)) {
                    this.form.isOverseas = OS_LGT;
                } else {
                    this.form.isOverseas = '';
                }
            } else {
                this.form.isOverseas = '';
            }
            this.isChina = '0';
            this.handleUpdateForm();
            if (Object.keys(this.submitForm).length) {
                this.confirmDisabled = true;
                chooseSupplierType(this.submitForm).then(res => {
                    this.options.businessTypeListOptions = [];
                    if (res && +res.code === 0) {
                        if (res.data && res.data.length) {
                            this.options.businessTypeListArr.forEach(e => {
                                for (const i of new Set(res.data)) {
                                    if (String(i) === e.value) {
                                        this.options.businessTypeListOptions.push(e);
                                    }
                                }
                            });
                        }
                    }
                }).finally(() => { this.confirmDisabled = false; });
            }
        },
        businessTypeListForm(val) {
            if (!val.length) { return false; } // 置空后取消执行
            this.form.transportType = '';
            this.form.corporateType = '';
            this.form.lesseeType = '';
            this.confirmDisabled = true;
            this.handleUpdateForm();
            supplierTypeConfigAssociation(this.submitForm).then(res => {
                this.options.corporateTypeOptions = [];
                this.options.transportTypeOptions = [];
                this.options.transTypeOptions = [];
                if (res && +res.code === 0) {
                    if (this.form.businessTypeList.indexOf(STORAGE_NUM) >= 0) { // 仓储
                        this.options.corporateTypeArr.forEach(e => {
                            for (const i of new Set(res.data.corporateTypeList)) {
                                if (String(i) === e.value) {
                                    this.options.corporateTypeOptions.push(e);
                                }
                            }
                        });
                    }
                    if (this.form.businessTypeList.some(item => [TRANSPORTATION_NUM, DS_NUM, BG_NUM].includes(item))) { // 运输|电商|报关
                        this.form.transportType = '';
                        this.options.transportTypeArr.forEach(e => {
                            for (const i of new Set(res.data.transportTypeList)) {
                                if (String(i) === e.value) {
                                    this.options.transportTypeOptions.push(e);
                                }
                            }
                        });
                    }
                    // 配送、快递或宅配
                    if (this.form.businessTypeList.indexOf(DISPATCH_NUM) >= 0 || this.form.businessTypeList.indexOf(EXPRESS_NUM) >= 0 || this.form.businessTypeList.indexOf(HOME_DELIVERY_NUM) >= 0) {
                        this.form.transType = '';
                        this.options.transTypeArr.forEach(e => {
                            for (const i of new Set(res.data.transTypeList)) {
                                if (String(i) === e.value) {
                                    this.options.transTypeOptions.push(e);
                                }
                            }
                        });
                    }
                }
            }).finally(() => { this.confirmDisabled = false; });
        },
        corporateTypeForm(val) {
            if (!val) { return false; } // 置空后取消执行
            this.form.lesseeType = '';
            this.handleUpdateForm();
            this.confirmDisabled = true;
            // chooseTransport(this.submitForm).then(res => {
            supplierTypeConfigAssociation(this.submitForm).then(res => {
                this.options.lesseeTypeOptions = [];
                if (res && +res.code === 0) {
                    this.options.lesseeTypeArr.forEach(e => {
                        for (const i of new Set(res.data.lesseeTypeList)) {
                            if (String(i) === e.value) {
                                this.options.lesseeTypeOptions.push(e);
                            }
                        }
                    });
                }
            }).finally(() => { this.confirmDisabled = false; });
        },
        transportTypeForm(val) {
            if (!val) { return false; } // 置空后取消执行
            this.form.transType = '';
            this.handleUpdateForm();
            this.confirmDisabled = true;
            supplierTypeConfigAssociation(this.submitForm).then(res => {
                this.options.transTypeOptions = [];
                if (res && +res.code === 0) {
                    this.options.transTypeArr.forEach(e => {
                        for (const i of new Set(res.data.transTypeList)) {
                            if (String(i) === e.value) {
                                this.options.transTypeOptions.push(e);
                            }
                        }
                    });
                }
            }).finally(() => { this.confirmDisabled = false; });
        }
    },
    mounted() {
        const list = [
            { optionName: 'supplierTypeOptions', optionNum: 'SYS_SUPPLIERS_TYPE' },
            { optionName: 'propertyNatureOptions', optionNum: 'SYS_SUPPLIERS_PROPERTY' },
            { optionName: 'isOverseasOptions', optionNum: 'SRM_IS_OVERSEAS' },
            { optionName: 'businessTypeListArr', optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND' },
            { optionName: 'transportTypeArr', optionNum: 'SRM_TRANSPORT_TYPE' },
            { optionName: 'transTypeArr', optionNum: 'SRM_SHIPPER_TYPE' },
            { optionName: 'corporateTypeArr', optionNum: 'SU_CORPORATE_TYPE' },
            { optionName: 'lesseeTypeArr', optionNum: 'SU_LEASE_TYPE' }
        ];
        dictWithUrl('SYS_SUPPLIERS_TYPE,SYS_SUPPLIERS_PROPERTY,SRM_IS_OVERSEAS,SRM_BUSYNESS_TYPE_BACKGROUND,SU_CORPORATE_TYPE,SRM_SHIPPER_TYPE,' +
         'SRM_TRANSPORT_TYPE,SU_LEASE_TYPE').then(res => {
            if (res && +res.code === 0) {
                delete res.data.SYS_SUPPLIERS_TYPE['100'];
                list.forEach(e => {
                    const arr = [];
                    for (const key in res.data[e.optionNum]) {
                        if (res.data[e.optionNum].hasOwnProperty(key)) {
                            arr.push({
                                value: key,
                                label: res.data[e.optionNum][key]
                            });
                        }
                    }
                    this.options[e.optionName] = arr;
                });
            }
        });
    }
};